//
import { API } from "../../api";
async function add_to_basket(request) {
    // console.log("add_to_basket -> request", request);
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_BASKET_URL ?? "",
        endpoint: `v2/add/product`,
        content: request,
    });
}
export { 
// IAddToBasketRequest,
add_to_basket, };
